<template>
  <div class="select-container relative">

    <div
      v-if="multiple"
      class="flex flex-wrap"
    >
      <div
        v-for="(tag, i) in tags"
        :key="i"
        class="bg-blue-500 p-2 rounded-full m-1"
      >

        <p class="text-white text-xs flex justify-center items-center">
          <img
            :src="tag[imageValue]"
            v-if="withImages && tag[imageValue]"
            class="w-6 pr-2 self-center py-0 h-auto"
          >
          {{ hasLocale ? tag[nameValue][locale] : tag[nameValue] }}
          <span
            @click="remove(tag)"
            class="cursor-pointer bullet-remove block w-4 h-4 mx-2 bg-white rounded-full text-blue-500 flex justify-center items-center text-xs"
          >
            x
          </span>
        </p>
      </div>
    </div>

    <div
      class="input-container"
      :class="[{'relative': withImages}, errors.first(`${vvScope !== '' ? vvScope + '.': ''}${vvName}`) ? vvClass : '']"
    >
      <img
        :src="selectedItem[imageValue]"
        v-if="withImages && selectedItem"
        class="has-image absolute w-5 py-0 h-auto ml-4"
      >
      <input
        :disabled="disabled"
        type="text"
        autocomplete="test"
        :placeholder="placeholder"
        @blur.stop="hideList"
        @input="showList"
        @click="showList"
        v-model="searchText"
        class="trigger-select h-12 mt-2 block border-blue-500 font-semibold text-gray-700 border w-full rounded px-4 outline-none"
        :class="[{'px-10' : withImages && selectedItem}]"
      >
      <span
        v-if="!multiple && !!selectedItem"
        class="has-icon absolute cursor-pointer bullet-remove block w-5 h-5 mx-2 bg-white rounded-full text-blue-500 flex justify-center items-center text-xs"
        @click="clearItem"
      >
        x
      </span>

      <input
        type="text"
        class="hidden"
        :data-vv-scope="vvScope"
        :data-vv-as="vvData"
        :name="vvName"
        :data-vv-name="vvName"
        v-validate="{required: isRequired}"
        v-model="fakeTextBox"
      >
      <ul>
        <li
          v-for="(error, index) in errors.collect(`${vvScope !== '' ? vvScope + '.': ''}${vvName}`)"
          :key="index"
          class="text-sm text-red-500 font-semibold mt-2 is-danger"
        >
          {{ error }}
        </li>
      </ul>
    </div>
    <div
      class="dropdown-list w-full absolute bg-white z-20 shadow-lg border"
      :class="[{'hidden': !show}]"
    >
      <ul class="w-full h-full">
        <li
          v-on="{click: !multiple ? setItem : addItem}"
          v-for="item in filtered"
          :key="item[itemValue]"
          :class="[
            'item-list py-2 px-2 text-base cursor-pointer hover:bg-gray-300',
            {'flex': withImages}, {'bg-blue-300': item.selected ? true : false}
          ]">
          <img
            :src="item[imageValue]"
            :alt="item[itemValue]"
            v-if="withImages && item[imageValue]"
            class="pr-4 w-8 h-auto self-center"
          >
          <p>{{ hasLocale ? item[nameValue][locale] : item[nameValue] }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    withimages: {
      type: Boolean,
      default: false
    },
    itemkey: {
      type: String,
      default: "id"
    },
    imagekey: {
      type: String,
      default: "image"
    },
    namekey: {
      type: String,
      default: "name"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    vvclass: {
      type: String,
      default: "has-errors"
    },
    vvscope: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    vvname: {
      type: String,
      default: "collection"
    },
    vvdata: {
      type: String,
      default: "collection"
    },
    require: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    selecteditem: {
      type: [String, Number, Object, Array],
      default() {
        return null;
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: Infinity
    },
    hasLocale: {
      type: Boolean,
      default: false
    },
    locale: {
      type: String,
      default: "en"
    },
    sorted: Boolean,
    setbeginners: {
      type: Array,
      default: function() {
        return [];
      }
    },
    vvtext: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchText: "",
      fakeTextBox: "",
      show: false,
      once: true,
      tags: [],
      withImages: false,
      itemValue: "",
      imageValue: "",
      nameValue: "",
      isDisabled: false,
      vvClass: "",
      vvScope: "",
      itemsGetter: null,
      vvName: "",
      vvData: "",
      isRequired: false,
      selectedItem: null
    };
  },
  created() {
    this.withImages = this.withimages;
    this.itemValue = this.itemkey;
    this.imageValue = this.imagekey;
    this.nameValue = this.namekey;
    this.isDisabled = this.disabled;
    this.vvClass = this.vvclass;
    this.vvScope = this.vvscope;
    this.vvName = this.vvname;
    this.vvData = this.vvdata;
    this.isRequired = this.require;
    this.fakeTextBox = this.vvtext;
  },
  updated() {
    /*if (!this.once && !this.selecteditem) {
      console.log('updated', this.selecteditem, this.selectedItem);
      this.searchText = "";
    }*/

    if (Array.isArray(this.selecteditem)) {
      if (
        this.multiple &&
        this.once &&
        this.selecteditem.length &&
        !this.tags.length
      ) {
        this.tags = Object.assign([], this.selecteditem);
        this.items.forEach(item =>
          this.tags.forEach(tag =>
            tag[this.itemValue] === item[this.itemValue]
              ? (item.selected = true)
              : null
          )
        );
        this.once = false;
      }
    }

    if (this.selecteditem && !this.selectedItem && this.once) {
      this.selectedItem = this.selecteditem;
      this.searchText = this.hasLocale
        ? this.selecteditem[this.nameValue][this.locale]
        : this.selecteditem[this.nameValue];

      this.once = false;
    }
  },
  computed: {
    filtered() {
      if (!this.searchText) {
        this.searchText = '';
      }

      let results = this.items.filter(item =>
        this.hasLocale
          ? item[this.nameValue][this.locale]
              .toLowerCase()
              .includes(this.searchText.toLowerCase())
          : item[this.nameValue]
              .toLowerCase()
              .includes(this.searchText.toLowerCase())
      );

      if (this.sorted) {
        if (this.hasLocale) {
          results.sort((a, b) =>
            a[this.nameValue][this.locale] > b[this.nameValue][this.locale]
              ? 1
              : -1
          );
        } else {
          results.sort((a, b) =>
            a[this.nameValue] > b[this.nameValue] ? 1 : -1
          );
        }
      }

      if (this.setbeginners.length && results.length) {
        // Get beginners from the result
        const beginners = results.find(i => this.setbeginners.includes(i.id));

        if (beginners) {
          // Exclude the items from the result
          results = results.filter(i => !this.setbeginners.includes(i.id));

          // Put beginners in the top or the results
          results.unshift(beginners);
        }
      }

      return results;
    }
  },
  methods: {
    hideList() {
      setTimeout(() => {
        this.show = false;
      }, 200);
    },
    showList(e) {
      this.show = true;
      if (e.type === "click") {
        return;
      }

      this.$emit("typing");

      if (this.tags.length === 0) {
        this.selectedItem = null;
        this.fakeTextBox = null;
        this.$emit("selected", null);
      }
    },
    setItem(e) {
      const { target } = e;
      let element = "";
      if (target.matches(".item-list")) {
        element = target.querySelector("p").textContent;
      } else if (target.matches(".item-list *")) {
        element = target.parentNode.querySelector("p").textContent;
      }

      this.selectedItem = this.items.find(
        item =>
          (this.hasLocale
            ? item[this.nameValue][this.locale]
            : item[this.nameValue]) === element
      );

      this.searchText = element;
      this.fakeTextBox = element;

      this.$emit("selected", this.selectedItem[this.itemValue]);
      this.$emit("input", this.selectedItem[this.itemValue]);
      this.show = false;
    },
    clearItem() {
      this.fakeTextBox = null;
      this.selectedItem = null;
      this.$emit("selected", null);
      this.$emit("input", null);
      this.searchText = "";
    },
    async addItem(e) {
      const { target } = e;
      let element = "";
      if (target.matches(".item-list")) {
        element = target.querySelector("p").textContent;
      } else if (target.matches(".item-list *")) {
        element = target.parentNode.querySelector("p").textContent;
      }

      const item = this.items.find(
        item =>
          (this.hasLocale
            ? item[this.nameValue][this.locale]
            : item[this.nameValue]) === element
      );

      if (item.selected) {
        return;
      }

      item.selected = true;
      this.fakeTextBox = element;

      if (this.tags.length + 1 <= this.limit) {
        this.tags.push(item);

        this.$emit("add", item[this.itemValue]);
        this.$emit("input", item[this.itemValue]);
      }
      this.searchText = "";
      this.show = false;
    },
    async remove(tagRemoved) {
      this.$emit("remove", tagRemoved[this.itemValue]);
      this.$emit("input", tagRemoved[this.itemValue]);

      this.tags = this.tags.filter(
        tag => tag[this.itemValue] !== tagRemoved[this.itemValue]
      );

      const item = this.items.find(
        item => item[this.itemValue] === tagRemoved[this.itemValue]
      );

      if (item) {
        item.selected = false;
      }

      if (!this.tags.length) {
        this.fakeTextBox = "";
      }
    }
  },
  watch: {
    selecteditem() {
      if (!this.selecteditem) {
        if (!this.multiple) {
          this.searchText = "";
          this.selectedItem = null;
        }
      } else {
        this.fakeTextBox = this.hasLocale ? this.selecteditem[this.nameValue][this.locale] : this.selecteditem[this.nameValue] ? this.selecteditem[this.nameValue] : this.selecteditem;
        this.searchText = this.hasLocale ? this.selecteditem[this.nameValue][this.locale] : this.selecteditem[this.nameValue] ? this.selecteditem[this.nameValue] : this.selecteditem;
      }
    }
  }
};
</script>

<style>
.has-image {
  display: flex;
}

.dropdown-list {
  max-height: 300px;
  overflow-y: auto;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.has-image {
  top: 50%;
  transform: translateY(-50%);
}

.has-icon {
  top: 50%;
  transform: translateY(-50%);
  right: 0;
}

.bullet-tag {
  line-height: 0;
  letter-spacing: 0;
  padding: 0;
  text-align: center;
  vertical-align: middle;
}
</style>
